import { render, staticRenderFns } from "./re_assign.vue?vue&type=template&id=c06d204e&scoped=true&"
import script from "./re_assign.vue?vue&type=script&lang=js&"
export * from "./re_assign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06d204e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c06d204e')) {
      api.createRecord('c06d204e', component.options)
    } else {
      api.reload('c06d204e', component.options)
    }
    module.hot.accept("./re_assign.vue?vue&type=template&id=c06d204e&scoped=true&", function () {
      api.rerender('c06d204e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/actions/re_assign.vue"
export default component.exports